import dayjs from "dayjs";
import type { Edition, IEdition } from "types";

const VIRTUAL_LEAD_MS = 1 * 60 * 60 * 1000;
const PHYSICAL_LEAD_MS = 2 * 60 * 60 * 1000;

function getRelevantSession(edition: IEdition, now: number) {
  const sessions = [...(edition.sessions ?? [])].sort((a, b) => Number(a.startDate) - Number(b.startDate));
  if (sessions.length === 0) return null;
  const current = sessions.find((s) => now >= Number(s.startDate) && now <= Number(s.endDate));
  const next = sessions.find((s) => now <= Number(s.startDate));
  return current ?? next ?? sessions[sessions.length - 1];
}

export function canJoinEdition(edition: IEdition, isVirtual: boolean, now: number = Date.now()): boolean {
  if (edition.status !== "E") return false;
  const session = getRelevantSession(edition, now);
  const sStart = session ? Number(session.startDate) : NaN;
  const sEnd = session ? Number(session.endDate) : NaN;
  const hasWindow = Number.isFinite(sStart) && Number.isFinite(sEnd);
  const meetingStart = hasWindow ? sStart : Number(edition.startTime);
  const meetingEnd = hasWindow ? sEnd : Number(edition.endTime);
  const lead = isVirtual ? VIRTUAL_LEAD_MS : PHYSICAL_LEAD_MS;
  return now >= meetingStart - lead && now <= meetingEnd;
}

export function getEditionMeetingUrl(edition: IEdition, now: number = Date.now()): string | null {
  const session = getRelevantSession(edition, now);
  return session?.link || edition.link || null;
}

export function oneEditionIsEnrolled(editions: Edition[] | undefined){
  let isAtLeastOneEditionEnrolled = editions?.some(edition =>  edition.status === "E");

  return isAtLeastOneEditionEnrolled ?? false;
}

export function isEnrolledLoStatus(status?: string){
  return status === "E" || status === "P" || status === "C";
}

export function oneUserEdition(editions: Edition[] | undefined){
  return editions?.some(edition => edition.status === "E" || edition.status === "C") ?? false;
}

export function isDisabled(
  disabled:boolean,
  isEnrolled:boolean,
  isCompleted:boolean,
  hasAvailablePlaces:boolean,
  editionEndTime:dayjs.Dayjs
){
  if(isEnrolled) return false;
  if(isCompleted) return true;
  if(disabled) return true;
  if(!hasAvailablePlaces) return true;
  if(editionEndTime < dayjs()) return true;

  return false;
}


export function displayRadio(
  selfEnrollment:boolean, 
  oneEditionIsEnrolled:boolean,
  editMode:boolean
){
  if(!selfEnrollment) return "none";
  if(!oneEditionIsEnrolled && selfEnrollment) return "inline";
  if(editMode && selfEnrollment) return "inline";
  if(!editMode && selfEnrollment) return "none";
  if(editMode && !selfEnrollment) return "none";
}


export function canSelfEnroll(selfEnrollment: boolean, enrollmentEnrollType?: string | null): boolean {
  return selfEnrollment || (!!enrollmentEnrollType && !enrollmentEnrollType.includes("TOP"));
}
